import React from 'react'
export const Error401 = () => <div style={{padding:24}}><h1>401</h1><p>Unauthorized</p></div>
